export default __webpack_public_path__ + "static/media/Conditions_09_22.dcbe6c33.pdf";